import Layout from '@/components/Layout/Vanilla';
import Hero from '@/components/Hero';
import Button from '@/components/Button';
import { DefaultLogoReel } from '@/components/LogoReel';
import Section from '@/components/Section';
import SectionHero from '@/components/SectionHero';
import IndustryList from '@/components/IndustryList';
import ContentBlock from '@/components/ContentBlock';
import StaffCard from '@/components/StaffCard';
import { fetchPage, gql } from '@/lib/graphcms';

export default function Careers({ founders, makers, page }) {
  const { contentBlocks } = page;

  return (
    <Layout seo={page}>
      <Section>
        <Hero {...page} alignment="left">
          <Button
            href="https://jobs.graphcms.com/"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Explore Vacancies at GraphCMS &#8594;
          </Button>
        </Hero>
      </Section>

      <DefaultLogoReel />

      <Section>
        <SectionHero
          title="Why Work at GraphCMS"
          description="We're set out to build the best Headless CMS out there - and that isn't possible without creating an atmosphere that encourages us to thrive."
        />
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>

      <Section colour="dark" container="narrow">
        <SectionHero
          noHr
          title="Meet Your Team"
          description="We're a bunch of passionate individuals, coming together to make a big impact. Join us in building the best Headless CMS on the market!"
        />

        <div className="flex flex-wrap lg:-mx-6">
          {founders.map(StaffCard)}
          {makers.map(StaffCard)}
        </div>
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { founders, makers, page } =
    (await fetchPage(
      gql`
        fragment staffData on Author {
          id
          name
          title
          bio
          photo {
            url(
              transformation: { image: { resize: { width: 560, fit: clip } } }
            )
            alt
          }
          twitterHandle
          linkedinUrl
        }

        query aboutUsPageQuery {
          founders: authors(where: { staff: true, department: EXEC }) {
            ...staffData
          }
          makers: authors(
            where: { staff: true, department_not: EXEC }
            orderBy: department_ASC
          ) {
            ...staffData
          }
          page: page(where: { slug: "careers" }) {
            ...pageData # Fragment is inside the method
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  return {
    props: {
      preview,
      founders,
      makers,
      page,
    },
    revalidate: 3600,
  };
};
